import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
        --icon-color: white;
    }

    .social-link sl-icon {
        color: var(--icon-color);
        width: 24px;
        height: 24px;
    }

    .container.row {
        display: flex;
        gap: var(--flex-gap);
    }

    .container.column {
        display: flex;
        flex-direction: column;
        gap: 0.2em;
    }

    .entry.column {
        display: flex;
        flex-direction: row;
        font-size: 0.9em;
    }

    .anchor {
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;
